import React, { useEffect, useState } from "react";
import { FormGroup, FormRow, WarningMessage, Row, Textarea } from "styles/forms/main";
import axios from "lib/api";
import { deleteSingleAttachment } from "modules/shared/api";
import {
    AccordionComponent,
    FixedDigitsInput,
    Input,
    RejectionReason,
    SelectWithSearch,
    UploadAttachments,
    VerifyComponent,
} from "components";
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";
import CheckBox from "components/checkbox";
import EditHandler from "./EditHandler";
import { NATIONALITY } from "../staticData";

function PersonalInfo({
    driverData,
    setDriverData,
    handleDataFroSubmit,
    isEditable,
    setIsEditable,
    setDriverExist,
    errors,
    isEidtSection,
    isQARole,
    uploadedAttachments,
    setAttachments,
    objections,
    isAuthorizedToCreate,
    handleObjections,
}) {
    const [isOnEdit, setIsOnEdit] = useState(false);
    const [objection, setObjections] = useState({});
    const getCurrentUserRole = useSelector(getUserRoles())?.filter((role) => role === "reviewer");
    const [isPassportExpired, setIsPassportExpired] = useState(false);
    const handleDeleteSingleAttachment = async (id) => {
        await deleteSingleAttachment(id)
            .then(() => {
                setAttachments(uploadedAttachments?.filter((item) => item?.id !== id));
            })
            .catch(() => {});
    };
    const handleDeleteAllAttachment = async (attachments) => {
        await Promise.all(
            // eslint-disable-next-line array-callback-return
            attachments.map((attachment) => {
                deleteSingleAttachment(attachment?.id);
            })
        ).then(() => {
            setAttachments([]);
        });
    };
    /**
     * Handles the verification of a national ID by making a GET request to the '/drivers' endpoint
     * with the provided national ID as a parameter. If the response contains no driver data, sets
     * the 'isEditable' state to true. Otherwise, sets the 'driverData' state.
     * @param {string} nationalId - the national ID to verify
     * @returns None
     */
    const handleNationalIdVerification = async (nationalId) => {
        await axios
            .get("drivers", {
                params: {
                    "filter[nationalId]": nationalId,
                    include: "supplier,paymentMethod",
                },
            })
            .then((res) => {
                if (res?.data?.length !== 0) {
                    /* show alert tells this driver exist */
                    // eslint-disable-next-line no-unused-expressions
                    !isEidtSection && setDriverExist(true);
                    // mapDrivertoUi(res, setDriverData)
                } else {
                    // eslint-disable-next-line no-unused-expressions
                    !isEidtSection && setDriverExist(false);
                    // eslint-disable-next-line no-unused-expressions
                    !isEidtSection && setIsEditable(true);
                }
            });
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    const checkIsPassportExpired = () => {
        if (driverData?.idExpiryDate) {
            const today = new Date();
            const expiryDate = new Date(driverData?.idExpiryDate);
            if (expiryDate < today) {
                setIsPassportExpired(true);
            } else {
                setIsPassportExpired(false);
            }
        }
    };

    useEffect(() => {
        checkIsPassportExpired();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [driverData?.idExpiryDate]);

    return (
        <AccordionComponent
            title="Personal Info"
            defaultExpanded
            extraAction={
                isEidtSection && (
                    <EditHandler
                        isOnEdit={isOnEdit}
                        setIsOnEdit={setIsOnEdit}
                    />
                )
            }
            body={
                <>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <SelectWithSearch
                                    label="Are you Egyptian?"
                                    name="nationality"
                                    error={errors?.nationality}
                                    errorMsg={errors?.nationality}
                                    isMulti={false}
                                    required
                                    isEditable={!isEidtSection ? true : isOnEdit}
                                    disable={isQARole}
                                    value={driverData?.nationality}
                                    options={NATIONALITY}
                                    handleChange={(value) =>
                                        handleDataFroSubmit(value, "nationality")
                                    }
                                />
                                {renderObjection("Nationality")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("nationality")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "nationality",
                                                "Nationality",
                                                "Personal Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.nationality?.verified
                                                ? objection?.nationality?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.nationality?.haveobjection
                                                ? objection?.nationality?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.nationality?.haveobjection && (
                                <Textarea
                                    required
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Nationality",
                                            "Personal Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                    autoFocus
                                    verifed={
                                        objection?.nationality?.verified
                                            ? objection?.nationality?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.nationality?.haveobjection
                                            ? objection?.nationality?.haveobjection
                                            : false
                                    }
                                />
                            )}
                        </FormGroup>
                        {(driverData?.nationality?.value === "syrian" ||
                            driverData?.nationality?.value === "sudanian" ||
                            driverData?.nationality?.value === "yemeni") && (
                            <FormGroup>
                                <Row>
                                    <FixedDigitsInput
                                        disabled={(isEidtSection && !isOnEdit) || isQARole}
                                        fields={11}
                                        label="National ID Number"
                                        name="nationalId"
                                        errorMessage={errors?.nationalId}
                                        required
                                        value={
                                            driverData?.nationalId &&
                                            driverData?.nationalId?.split("")
                                        }
                                        onChange={(value) => {
                                            setDriverData({
                                                ...driverData,
                                                nationalId: value,
                                            });
                                        }}
                                        onComplete={(value) => handleNationalIdVerification(value)}
                                    />
                                    {renderObjection("Nationality ID Number")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("nationalId")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "nationalId",
                                                    "Nationality ID Number",
                                                    "Personal Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.nationalId?.verified
                                                    ? objection?.nationalId?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.nationalId?.haveobjection
                                                    ? objection?.nationalId?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.nationalId?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Nationality ID Number",
                                                "Personal Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        )}
                        {(driverData?.nationality?.value === "egyptian" ||
                            driverData?.nationality?.value === "libyan") && (
                            <FormGroup>
                                <Row>
                                    <FixedDigitsInput
                                        disabled={(isEidtSection && !isOnEdit) || isQARole}
                                        // disabled={isOnEdit && !isOnEdit}
                                        fields={14}
                                        label="National ID Number"
                                        name="nationalId"
                                        errorMessage={errors?.nationalId}
                                        required
                                        value={
                                            driverData?.nationalId &&
                                            driverData?.nationalId?.split("")
                                        }
                                        onChange={(value) => {
                                            setDriverData({
                                                ...driverData,
                                                nationalId: value,
                                            });
                                        }}
                                        onComplete={(value) => handleNationalIdVerification(value)}
                                    />
                                    {renderObjection("Nationality ID Number")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("nationalId")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "nationalId",
                                                    "Nationality ID Number",
                                                    "Personal Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.nationalId?.verified
                                                    ? objection?.nationalId?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.nationalId?.haveobjection
                                                    ? objection?.nationalId?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.nationalId?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Nationality ID Number",
                                                "Personal Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        )}
                        {driverData?.nationality?.value === "palestinian" && (
                            <FormGroup>
                                <Row>
                                    <FixedDigitsInput
                                        disabled={isEidtSection && !isOnEdit}
                                        // disabled={isOnEdit && !isOnEdit}
                                        fields={12}
                                        label="National ID Number"
                                        name="nationalId"
                                        errorMessage={errors?.nationalId}
                                        required
                                        value={
                                            driverData?.nationalId &&
                                            driverData?.nationalId?.split("")
                                        }
                                        onChange={(value) => {
                                            setDriverData({
                                                ...driverData,
                                                nationalId: value,
                                            });
                                        }}
                                        onComplete={(value) => handleNationalIdVerification(value)}
                                    />
                                    {renderObjection("Nationality ID Number")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("nationalId")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "nationalId",
                                                    "Nationality ID Number",
                                                    "Personal Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.nationalId?.verified
                                                    ? objection?.nationalId?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.nationalId?.haveobjection
                                                    ? objection?.nationalId?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.nationalId?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Nationality ID Number",
                                                "Personal Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        )}
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <Input
                                    isEditable={isEditable || isOnEdit}
                                    label="Name(Arabic)"
                                    errorMessage={errors?.name}
                                    name="name"
                                    type="text"
                                    required
                                    placeholder="مثال: محمد أحمد محمود"
                                    value={driverData?.name}
                                    onChange={(e) => handleDataFroSubmit(e)}
                                    disable={isQARole}
                                />
                                {renderObjection("Name (Arabic)")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("name")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "name",
                                                "Name (Arabic)",
                                                "Personal Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.name?.verified
                                                ? objection?.name?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.name?.haveobjection
                                                ? objection?.name?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.name?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Name (Arabic)",
                                            "Personal Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Input
                                    isEditable={isEditable || isOnEdit}
                                    label="Mobile Number"
                                    errorMessage={errors?.phoneNumber}
                                    name="phoneNumber"
                                    type="text"
                                    required
                                    placeholder="0100000000"
                                    onChange={(e) => handleDataFroSubmit(e)}
                                    value={driverData?.phoneNumber}
                                    disable={isQARole}
                                    component={
                                        !isQARole && (
                                            <div style={{ width: "18%" }}>
                                                <SelectWithSearch
                                                    value={{ value: "+2", label: "+2" }}
                                                    disable
                                                    isEditable
                                                />
                                            </div>
                                        )
                                    }
                                />
                                {renderObjection("Mobile Number")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("phoneNumber")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "phoneNumber",
                                                "Mobile Number",
                                                "Personal Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.phoneNumber?.verified
                                                ? objection?.phoneNumber?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.phoneNumber?.haveobjection
                                                ? objection?.phoneNumber?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.phoneNumber?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Mobile Number",
                                            "Personal Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <Row>
                                <Input
                                    isEditable={isEditable || isOnEdit}
                                    name="email"
                                    type="email"
                                    errorMessage={errors?.email}
                                    label="Email"
                                    placeholder="example@mail.com"
                                    onChange={(e) => handleDataFroSubmit(e)}
                                    value={driverData?.email}
                                />
                                {renderObjection("Email")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() => openObjectionhandler("email")}
                                        handleVerify={() =>
                                            handleVerify(
                                                "email",
                                                "Email",
                                                "Personal Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.email?.verified
                                                ? objection?.email?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.email?.haveobjection
                                                ? objection?.email?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.email?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Email",
                                            "Personal Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                        <FormGroup>
                            <CheckBox
                                disabled={!(isEditable || isOnEdit)}
                                name="isTruckOwner"
                                label="This driver is truck owner"
                                value={driverData?.isTruckOwner}
                                onChange={(e) =>
                                    handleDataFroSubmit(e.target?.checked, "isTruckOwner")
                                }
                            />
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        {driverData?.nationality?.value !== "egyptian" &&
                            driverData?.nationality?.value && (
                                <FormGroup>
                                    <Row>
                                        <Input
                                            type="text"
                                            name="passportNumber"
                                            min={new Date().toISOString().split("T")[0]}
                                            error={errors?.passportNumber}
                                            isEditable={isEditable || isOnEdit}
                                            required
                                            placeholder="000000000"
                                            label="Passport Number"
                                            value={driverData?.passportNumber}
                                            onChange={(e) => handleDataFroSubmit(e)}
                                        />
                                        {renderObjection("Passport Number")}
                                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                            <VerifyComponent
                                                objectionHandler={() =>
                                                    openObjectionhandler("passportNumber")
                                                }
                                                handleVerify={() =>
                                                    handleVerify(
                                                        "passportNumber",
                                                        "Passport Number",
                                                        "Personal Info - Driver",
                                                        "driver_profile"
                                                    )
                                                }
                                                verifed={
                                                    objection?.passportNumber?.verified
                                                        ? objection?.passportNumber?.verified
                                                        : false
                                                }
                                                objection={
                                                    objection?.passportNumber?.haveobjection
                                                        ? objection?.passportNumber?.haveobjection
                                                        : false
                                                }
                                            />
                                        )}
                                    </Row>
                                    {objection?.passportNumber?.haveobjection && (
                                        <Textarea
                                            required
                                            autoFocus
                                            onBlur={(e) =>
                                                handleObjections(
                                                    e,
                                                    "Passport Number",
                                                    "Personal Info - Driver",
                                                    "driver_profile",
                                                    false
                                                )
                                            }
                                        />
                                    )}
                                </FormGroup>
                            )}
                        <FormGroup>
                            <Row>
                                <Input
                                    type="date"
                                    name="idExpiryDate"
                                    min={new Date().toISOString().split("T")[0]}
                                    error={errors?.idExpiryDate}
                                    isEditable={isEditable || isOnEdit}
                                    required
                                    placeholder="DD/MM/YYY"
                                    label={
                                        driverData?.nationality?.value === "egyptian"
                                            ? "ID Expiration Date"
                                            : "Passport Expiration Date"
                                    }
                                    value={driverData?.idExpiryDate}
                                    onChange={(e) => handleDataFroSubmit(e)}
                                />
                                {isPassportExpired && (
                                    <WarningMessage>
                                        Be noted that this id is expired.
                                    </WarningMessage>
                                )}
                                {renderObjection("ID Expiration Date")}
                                {renderObjection("Passport Expiration Date")}
                                {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                    <VerifyComponent
                                        objectionHandler={() =>
                                            openObjectionhandler("idExpiryDate")
                                        }
                                        handleVerify={() =>
                                            handleVerify(
                                                "idExpiryDate",
                                                driverData?.nationality?.value === "egyptian"
                                                    ? "ID Expiration Date"
                                                    : "Passport Expiration Date",
                                                "Personal Info - Driver",
                                                "driver_profile"
                                            )
                                        }
                                        verifed={
                                            objection?.idExpiryDate?.verified
                                                ? objection?.idExpiryDate?.verified
                                                : false
                                        }
                                        objection={
                                            objection?.idExpiryDate?.haveobjection
                                                ? objection?.idExpiryDate?.haveobjection
                                                : false
                                        }
                                    />
                                )}
                            </Row>
                            {objection?.idExpiryDate?.haveobjection && (
                                <Textarea
                                    required
                                    autoFocus
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            driverData?.nationality?.value === "egyptian"
                                                ? "ID Expiration Date"
                                                : "Passport Expiration Date",
                                            "Personal Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                    </FormRow>
                    {driverData?.nationality?.value === "egyptian" && (
                        <FormRow>
                            <FormGroup>
                                <Row>
                                    <UploadAttachments
                                        name="nationalIdFace"
                                        required
                                        maxLength={1}
                                        isEditable={isEditable || isOnEdit}
                                        errorMessage={errors?.nationalIdFace}
                                        onFilesChange={(e) =>
                                            handleDataFroSubmit(e, "nationalIdFace")
                                        }
                                        label="ID Photo - Face "
                                        uploadedAttachments={uploadedAttachments?.filter(
                                            (item) => item?.documentType === "national_id_face"
                                        )}
                                        onDeleteUploadedItem={handleDeleteSingleAttachment}
                                        onDeleteAllAttachements={() =>
                                            handleDeleteAllAttachment(
                                                uploadedAttachments?.filter(
                                                    (item) =>
                                                        item?.documentType === "national_id_face"
                                                )
                                            )
                                        }
                                        showConfirmation
                                    />
                                    {renderObjection("ID Photo - Face")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("nationalIdFace")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "nationalIdFace",
                                                    "ID Photo - Face",
                                                    "Personal Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.nationalIdFace?.verified
                                                    ? objection?.nationalIdFace?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.nationalIdFace?.haveobjection
                                                    ? objection?.nationalIdFace?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.nationalIdFace?.haveobjection && (
                                    <Textarea
                                        autoFocus
                                        required
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "ID Photo - Face",
                                                "Personal Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <UploadAttachments
                                        name="nationalIdBack"
                                        maxLength={1}
                                        errorMessage={errors?.nationalIdBack}
                                        required
                                        label="ID Photo - Back "
                                        isEditable={isEditable || isOnEdit}
                                        onFilesChange={(e) =>
                                            handleDataFroSubmit(e, "nationalIdBack")
                                        }
                                        uploadedAttachments={uploadedAttachments?.filter(
                                            (item) => item?.documentType === "national_id_back"
                                        )}
                                        onDeleteUploadedItem={handleDeleteSingleAttachment}
                                        onDeleteAllAttachements={() =>
                                            handleDeleteAllAttachment(
                                                uploadedAttachments?.filter(
                                                    (item) =>
                                                        item?.documentType === "national_id_back"
                                                )
                                            )
                                        }
                                        showConfirmation
                                    />
                                    {renderObjection("ID Photo - Back")}
                                    {getCurrentUserRole[0] === "reviewer" && isQARole && (
                                        <VerifyComponent
                                            objectionHandler={() =>
                                                openObjectionhandler("nationalIdBack")
                                            }
                                            handleVerify={() =>
                                                handleVerify(
                                                    "nationalIdBack",
                                                    "ID Photo - Back",
                                                    "Personal Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.nationalIdBack?.verified
                                                    ? objection?.nationalIdBack?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.nationalIdBack?.haveobjection
                                                    ? objection?.nationalIdBack?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                                </Row>
                                {objection?.nationalIdBack?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "ID Photo - Back",
                                                "Personal Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        </FormRow>
                    )}
                    <FormRow>
                        {driverData?.nationality?.value !== "egyptian" && (
                            <FormGroup>
                                <Row>
                                    <UploadAttachments
                                        name="passport"
                                        maxLength={1}
                                        errorMessage={errors?.passport}
                                        required
                                        isEditable={isEditable || isOnEdit}
                                        onFilesChange={(e) => handleDataFroSubmit(e, "passport")}
                                        label="Passport Photo  "
                                        uploadedAttachments={uploadedAttachments?.filter(
                                            (item) => item?.documentType === "passport"
                                        )}
                                        onDeleteUploadedItem={handleDeleteSingleAttachment}
                                        onDeleteAllAttachements={() =>
                                            handleDeleteAllAttachment(
                                                uploadedAttachments?.filter(
                                                    (item) => item?.documentType === "passport"
                                                )
                                            )
                                        }
                                        showConfirmation
                                    />
                                    {renderObjection("Passport")}
                                    {getCurrentUserRole[0] === "reviewer" &&
                                        uploadedAttachments?.filter(
                                            (item) => item?.documentType === "passport"
                                        )?.length === 1 &&
                                        isQARole && (
                                            <VerifyComponent
                                                objectionHandler={() =>
                                                    openObjectionhandler("passport")
                                                }
                                                handleVerify={() =>
                                                    handleVerify(
                                                        "passport",
                                                        "Passport",
                                                        "Personal Info - Driver",
                                                        "driver_profile"
                                                    )
                                                }
                                                verifed={
                                                    objection?.passport?.verified
                                                        ? objection?.passport?.verified
                                                        : false
                                                }
                                                objection={
                                                    objection?.passport?.haveobjection
                                                        ? objection?.passport?.haveobjection
                                                        : false
                                                }
                                            />
                                        )}
                                </Row>
                                {objection?.passport?.haveobjection && (
                                    <Textarea
                                        required
                                        autoFocus
                                        onBlur={(e) =>
                                            handleObjections(
                                                e,
                                                "Passport",
                                                "Personal Info - Driver",
                                                "driver_profile",
                                                false
                                            )
                                        }
                                    />
                                )}
                            </FormGroup>
                        )}
                        <FormGroup>
                            <Row>
                                <UploadAttachments
                                    name="photo"
                                    label="Driver Picture"
                                    maxLength={1}
                                    isEditable={isEditable || isOnEdit}
                                    errorMessage={errors?.photo}
                                    onFilesChange={(e) =>
                                        setDriverData({
                                            ...driverData,
                                            photo: e,
                                        })
                                    }
                                    uploadedAttachments={uploadedAttachments?.filter(
                                        (item) => item?.documentType === "photo"
                                    )}
                                    onDeleteUploadedItem={handleDeleteSingleAttachment}
                                    onDeleteAllAttachements={() =>
                                        handleDeleteAllAttachment(
                                            uploadedAttachments?.filter(
                                                (item) => item?.documentType === "photo"
                                            )
                                        )
                                    }
                                    showConfirmation
                                />
                                {renderObjection("Driver Picture")}
                                {getCurrentUserRole[0] === "reviewer" &&
                                    uploadedAttachments?.filter(
                                        (item) => item?.documentType === "photo"
                                    )?.length === 1 && (
                                        <VerifyComponent
                                            objectionHandler={() => openObjectionhandler("photo")}
                                            handleVerify={() =>
                                                handleVerify(
                                                    "photo",
                                                    "Driver Picture",
                                                    "Personal Info - Driver",
                                                    "driver_profile"
                                                )
                                            }
                                            verifed={
                                                objection?.photo?.verified
                                                    ? objection?.photo?.verified
                                                    : false
                                            }
                                            objection={
                                                objection?.photo?.haveobjection
                                                    ? objection?.photo?.haveobjection
                                                    : false
                                            }
                                        />
                                    )}
                            </Row>
                            {objection?.photo?.haveobjection && (
                                <Textarea
                                    autoFocus
                                    required
                                    onBlur={(e) =>
                                        handleObjections(
                                            e,
                                            "Driver Picture",
                                            "Personal Info - Driver",
                                            "driver_profile",
                                            false
                                        )
                                    }
                                />
                            )}
                        </FormGroup>
                    </FormRow>
                </>
            }
        />
    );
}

export default PersonalInfo;
